module.exports = "<!--The whole content below can be removed with the new code.-->\r\n<div *ngIf=\"ready\">\r\n  <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0